/**
 * @generated SignedSource<<5007b15defff34e7476acae1365e5be9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AssociationType = "MANDATORY" | "OPTIONAL";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
import { FragmentRefs } from "relay-runtime";
export type deReferralLetterFragment$data = {
  readonly allergies: ReadonlyArray<string> | null;
  readonly concludedAt: string | null;
  readonly concludedBy: string | null;
  readonly conditions: ReadonlyArray<string> | null;
  readonly createdAt: string;
  readonly createdBy: string;
  readonly fileId: string | null;
  readonly fileMetadata: {
    readonly documentType: string;
    readonly extension: string;
    readonly lengthInKilobytes: number;
  } | null;
  readonly icdDiagnosis: {
    readonly associationType: AssociationType | null;
    readonly diagnosisCode: string;
    readonly id: string;
    readonly isAssociation: boolean;
    readonly primaryCode: string | null;
    readonly secondaryCode: string | null;
    readonly text: string;
  };
  readonly id: string;
  readonly medicationIds: ReadonlyArray<string> | null;
  readonly patientId: string;
  readonly progressNote: {
    readonly pointOfCare: {
      readonly pointOfCareSpecialty: {
        readonly id: string;
        readonly language: Language;
        readonly synonym: string | null;
        readonly word: string;
      } | null;
    } | null;
  };
  readonly progressNoteId: string;
  readonly reasoning: string | null;
  readonly referralId: number;
  readonly signedAt: string | null;
  readonly signedBy: string | null;
  readonly updatedAt: string | null;
  readonly updatedBy: string | null;
  readonly " $fragmentType": "deReferralLetterFragment";
};
export type deReferralLetterFragment$key = {
  readonly " $data"?: deReferralLetterFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"deReferralLetterFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "deReferralLetterFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reasoning",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "medicationIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "conditions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allergies",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IcdDiagnosis",
      "kind": "LinkedField",
      "name": "icdDiagnosis",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAssociation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "diagnosisCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondaryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "associationType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "de_ProgressNote",
      "kind": "LinkedField",
      "name": "progressNote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "de_PointOfCare",
          "kind": "LinkedField",
          "name": "pointOfCare",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PointOfCareSpecialty",
              "kind": "LinkedField",
              "name": "pointOfCareSpecialty",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "language",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "synonym",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "word",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentFileMetadata",
      "kind": "LinkedField",
      "name": "fileMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extension",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lengthInKilobytes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "de_ReferralLetter",
  "abstractKey": null
};
})();

(node as any).hash = "681d1d1b3cc8dc75fbeccf6ff828ea04";

export default node;
